import {
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_INIT,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_FAILURE,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_NO_LOADING_INIT,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_NO_LOADING_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_NO_LOADING_FAILURE,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_COUNT_INIT,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_COUNT_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_COUNT_FAILURE,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_TASK_INIT,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_TASK_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_TASK_FAILURE,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_SAVE_TASK_INIT,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_SAVE_TASK_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_SAVE_TASK_FAILURE,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_GET_TASK_FIELD_ENDPOINT_INIT,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_GET_TASK_FIELD_ENDPOINT_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_GET_TASK_FIELD_ENDPOINT_FAILURE,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_CHANGE_FORM_VALUE, 
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_ANNUL_INIT,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_ANNUL_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_ANNUL_FAILURE,
  RESET_TASKS_MANAGER_TAB_NOTIFICATIONS_TASK,
  RESET_TASKS_MANAGER_TAB_NOTIFICATIONS,
  SET_FILTER_TASKS_MANAGER_TAB_NOTIFICATIONS,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_DOWNLOADING_INIT,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_DOWNLOADING_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_DOWNLOADING_FAILURE
} from './types';
import API from '../tasks_manager/api';

/* Actions Creators */

export function handleChangeFormValue(fieldKey, fieldValue) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_CHANGE_FORM_VALUE,
    fieldKey: fieldKey,
    fieldValue: fieldValue
  };
}

export function setFilterTasksManager(obj) {
  return {
    type: SET_FILTER_TASKS_MANAGER_TAB_NOTIFICATIONS,
    payload: obj
  };
}

export function resetTasksManager() {
  return {
    type: RESET_TASKS_MANAGER_TAB_NOTIFICATIONS
  };
}

/* Data  */
function fetchApiSuccess(data) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_INIT
  };
}

export function fetchTasksManagerApi(obj) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Data  count */
function fetchCountApiSuccess(data) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_COUNT_SUCCESS,
    payload: data
  };
}

function fetchCountApiFailure(error) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_COUNT_FAILURE,
    payload: error
  };
}

function fetchCountApiInit() {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_COUNT_INIT
  };
}

export function fetchTasksManagerCountApi(obj) {
  return async dispatch => {
    dispatch(fetchCountApiInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchCountApiSuccess(data));
    } catch (error) {
      dispatch(fetchCountApiFailure(error));
    }
  };
}

/*  No loading */

function fetchNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_NO_LOADING_SUCCESS,
    payload: data,
    concat
  };
}

function fetchNoLoadingFailure(error) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_NO_LOADING_INIT
  };
}

export function fetchTasksManagerNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchNoLoadingFailure(error));
    }
  };
}

export function downloadSummaryReport(filter) {
  return async (dispatch) => {
    dispatch(downloadReportInit());
    try {
      let data = await API.data.handleDownloadSummaryReport(filter);
      dispatch(downloadReportSuccess(data));
    } catch (error) {
      dispatch(downloadReportFailure(error));
    }
  };
}

export function downloadNoProcessReport(filter) {
  return async (dispatch) => {
    dispatch(downloadReportInit());
    try {
      let data = await API.data.handleDownloadNoProcessReport(filter);
      dispatch(downloadReportSuccess(data));
    } catch (error) {
      dispatch(downloadReportFailure(error));
    }
  };
}

/* Task  */
function fetchTaskApiSuccess(data) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_TASK_SUCCESS,
    payload: data
  };
}

function fetchTaskApiFailure(error) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_TASK_FAILURE,
    payload: error
  };
}

function fetchTaskApiInit(data) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_TASK_INIT,
    payload: data
  };
}

export function fetchTasksManagerTaskApi(obj) {
  return async dispatch => {
    dispatch(fetchTaskApiInit(obj));
    try {
      let data = await API.data.getTask(obj);
      dispatch(fetchTaskApiSuccess(data));
    } catch (error) {
      dispatch(fetchTaskApiFailure(error));
    }
  };
}

export function resetTasksManagerTask() {
  return {
    type: RESET_TASKS_MANAGER_TAB_NOTIFICATIONS_TASK
  };
}

/* Annul  */
function annulTasksSuccess(data) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_ANNUL_SUCCESS,
    payload: data
  };
}

function annulTasksFailure(error) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_ANNUL_FAILURE,
    payload: error
  };
}

function annulTasksInit(data) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_ANNUL_INIT,
    payload: data
  };
}

export function annulTasksApi(ids) {
  return async dispatch => {
    dispatch(annulTasksInit(ids));
    try {
      let data = await API.data.annulTasks(ids);
      dispatch(annulTasksSuccess(data));
    } catch (error) {
      dispatch(annulTasksFailure(error));
    }
  };
}

function saveTaskApiSuccess(data) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_SAVE_TASK_SUCCESS,
    payload: data
  };
}

function saveTaskApiFailure(error) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_SAVE_TASK_FAILURE,
    payload: error
  };
}

function saveTaskApiInit(action) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_SAVE_TASK_INIT,
    action: action
  };
}

export function saveTaskApi(id,taskData,files) {
  return async dispatch => {
    dispatch(saveTaskApiInit(taskData.action));
    try {
      let data = await API.data.saveTask(id,taskData,files);
      dispatch(saveTaskApiSuccess(data));
    } catch (error) {
      dispatch(saveTaskApiFailure(error));
    }
  };
}

function getFieldEnpointDataSuccess(fieldKey, data) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_GET_TASK_FIELD_ENDPOINT_SUCCESS,
    fieldKey: fieldKey,
    payload: data
  };
}

function getFieldEnpointDataFailure(fieldKey, error) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_GET_TASK_FIELD_ENDPOINT_FAILURE,
    fieldKey: fieldKey,
    payload: error
  };
}

function getFieldEnpointDataInit(fieldKey) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_GET_TASK_FIELD_ENDPOINT_INIT,
    fieldKey: fieldKey
  };
}

export function getFieldEnpointData(obj) {
  return async dispatch => {
    dispatch(getFieldEnpointDataInit(obj.fieldKey));
    try {
      let data = await API.data.getFieldEnpointData(obj);
      dispatch(getFieldEnpointDataSuccess(obj.fieldKey, data));
    } catch (error) {
      dispatch(getFieldEnpointDataFailure(obj.fieldKey, error));
    }
  };
}

export function getTaskFile(obj) {
  return async (dispatch) => {
    try {
      let data = await API.data.getTaskFile(obj);
    } catch (error) {}
  };
}

/*  downloading report */
function downloadReportInit() {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_DOWNLOADING_INIT
  };
}

function downloadReportSuccess(data) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_DOWNLOADING_SUCCESS,
    payload: data
  };
}

function downloadReportFailure(error) {
  return {
    type: FETCH_TASKS_MANAGER_TAB_NOTIFICATIONS_DOWNLOADING_FAILURE,
    payload: error
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/tasks_manager_tab_notifications/index.js